import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';

import Button from '../common/inputs/button';
import Spinner from '../common/interface/spinner';

const MetricGroupsLoadData = props => {
  const {
    metricGroups,
    handleMetricGroupClick,
    metricsDataUploadInfoArray,
    selectedPolynomialId,
    polynomialFilterTreeInfoData,
    handleRefreshVirtualMetricData, //function: handler for refresh virtual metric data button
    isPeriodLoadData, //boolean: true if the component instance is for the metric groups associated with period dimension 
  } = props;
  
  return (
    <React.Fragment>
      <div className={"load_data_section " + (isPeriodLoadData ? "period_load_data_wrapper" : "no_period_load_data_wrapper")}>
        <h3>{ isPeriodLoadData ? 
          <FormattedMessage id="periodAdmin.loadDataTitlePeriodData"/> :
          <FormattedMessage id="periodAdmin.loadDataTitleNoPeriodData"/>
        }
        </h3>
        <div>        
          {metricGroups && metricGroups.map((item,i) => {
            let has_period = item.has_period > 0 ? true : false;
            if((has_period!=isPeriodLoadData) || selectedPolynomialId==""){
              return null;
            }
            let incompleteUploadedData = true;
            let virtualMetricPendingRefresh = false;
            let metricsDataUploadInfo = metricsDataUploadInfoArray[i].data;
            let metricsDataUploadInfoStatus = metricsDataUploadInfoArray[i].status;
            let metricsDataUploadInfoLoading = metricsDataUploadInfoArray[i].loading;
            let metric_version_ids = (item.metric_version_ids ? item.metric_version_ids.split(",") : []);
            let metricVersionsIdsFilter = selectedPolynomialId == Constants.selectKeys.periodAdmin.allModelsSelectKey ?
                null : polynomialFilterTreeInfoData["polynomial_tree_info"]["metric_versions_ids_used"];
            let showInPolynomialFilter = false;
            metric_version_ids.forEach(metric_version_id => {
              showInPolynomialFilter = (metricVersionsIdsFilter && metricVersionsIdsFilter.includes(metric_version_id)) ? true : showInPolynomialFilter;
              let findedInfo = (!metricsDataUploadInfoLoading && metricsDataUploadInfoStatus==200) ? metricsDataUploadInfo.find(info => info.metric_version_id == metric_version_id) : null;
              incompleteUploadedData = (findedInfo && findedInfo.count > 0) ? false : incompleteUploadedData;
              virtualMetricPendingRefresh = (findedInfo && findedInfo.virtual_metric_regenerate_pending) ? true : virtualMetricPendingRefresh;
            });
            if(selectedPolynomialId != Constants.selectKeys.periodAdmin.allModelsSelectKey && selectedPolynomialId && !showInPolynomialFilter) {
              return null;
            }
            return (
              <div key={i} className="metric_group_load_data_wrapper">
                {(item.metric_type == Constants.metricAdmin.metricType.STANDARD || item.metric_type == null)  && (
                  <Button
                    onClick={handleMetricGroupClick}
                    data-entitydata={JSON.stringify(item)}
                    labelLocale={metricsDataUploadInfoLoading ? <FormattedMessage id="periodAdmin.loadingMetricData"/> : <FormattedMessage id="periodAdmin.importData"/>}
                    disabled={metricsDataUploadInfoLoading}
                  />
                )}
                {item.metric_type == Constants.metricAdmin.metricType.VIRTUAL && (
                  <React.Fragment>
                    <Button
                      onClick={handleRefreshVirtualMetricData}
                      data-entitydata={JSON.stringify(item)}
                      labelLocale={metricsDataUploadInfoLoading ? <FormattedMessage id="periodAdmin.loadingMetricData"/> : (
                        virtualMetricPendingRefresh ? <FormattedMessage id="periodAdmin.importVirtualMetricsData"/> : <FormattedMessage id="periodAdmin.readyVirtualMetricsData"/>
                      )}
                      disabled={!virtualMetricPendingRefresh || metricsDataUploadInfoLoading}
                      className={virtualMetricPendingRefresh ? "virtual_metric_refresh_button_pending" : ""}
                    />
                  </React.Fragment>
                )}
                {item.metric_type == Constants.metricAdmin.metricType.DYNAMIC && (
                  <Button
                    onClick={()=>{}}
                    data-entitydata={JSON.stringify(item)}
                    labelLocale={metricsDataUploadInfoLoading ? <FormattedMessage id="periodAdmin.loadingMetricData"/> : <FormattedMessage id="periodAdmin.importDynamicMetricsData"/>}
                    disabled={true}
                  />
                )}
                <div className="metric_group_load_data_wrapper_name">
                  {item.name}
                  {(metricsDataUploadInfoLoading) && (<Spinner/>)}
                  {(!metricsDataUploadInfoLoading && metricsDataUploadInfoStatus==200 && (
                    item.metric_type != Constants.metricAdmin.metricType.VIRTUAL || !virtualMetricPendingRefresh
                  )) && (               
                    <span>
                      {(incompleteUploadedData && item.required) && (<i className="fas fa-times-circle no-data-info" title={intl.formatMessage({id:"periodAdmin.noDataInfo"})}/>)}
                      {(incompleteUploadedData && !item.required) && (<i className="fas fa-exclamation-circle optional-no-data-info" title={intl.formatMessage({id: "periodAdmin.optionalNoDataInfo"})}/>)}
                      {!incompleteUploadedData && (<i className="fas fa-check-circle some-data-info" title={intl.formatMessage({ id: "periodAdmin.someDataInfo"})}/>)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default MetricGroupsLoadData;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/metricGroupsLoadData.jsx